<template>
    <div style="display: inline-block" >
        <el-date-picker
                v-model="date"
                style="width: 150px"
                format="yyyy年M月"
                value-format="yyyy-MM"
                @change="handleSelectInputClick"
                type="month"
                placeholder="选择月">
        </el-date-picker>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "reportMonth",
        props: {
            handleSelectInput:{
                type:Function,
                default:null
            }
        },
        data(){
            return{
                date:this.GLOBAL.date ? this.GLOBAL.date : new Date()
            }

        },
        created(){
            this.handleSelectInputClick()

        },
        methods:{
            handleSelectInputClick(){
                if(this.date){
                    this.GLOBAL.date = moment(this.date).format('YYYY-M')
                }else{
                    this.GLOBAL.date = ''
                }
                this.handleSelectInput(this.date)
            }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/statement/components/reportMonth.vue